import _ from 'lodash'

/**
 * 이미지/비디오 주소를 CDN 주소로 변환한다.
 * @param {string} mediaSrc - CDN 주소가 포함되지 않은 이미지/비디오 주소
 * @returns {string} CDN 주소로 변환된 이미지/비디오 주소
 */
export function getCdnUrl (mediaSrc) {
  if (mediaSrc && (mediaSrc.startsWith('blob:') || mediaSrc.startsWith('data:'))) {
    return mediaSrc
  }
  let mediaUrl = process.env.WEB_BASE_URL + '/images/tempLy/noimage.png'
  if (mediaSrc) {
    if (/^https?:\/\//i.test(mediaSrc) || mediaSrc.includes(process.env.CDN_BASE_URL)) {
      mediaUrl = mediaSrc
    } else {
      let url = process.env.CDN_BASE_URL
      url = (mediaSrc.charAt(0) !== '/' ? url + '/' : url) + mediaSrc
      mediaUrl = _.unescape(url)
    }
  }
  return isEncoded(mediaUrl) ? mediaUrl : encodeURI(mediaUrl)
}

/**
 * URL 인코딩 여부를 체크한다.
 * @param {string} url - 이미지/비디오 URL
 * @returns {boolean} 인코딩 여부
 */
export function isEncoded (url) {
  try {
    return url !== decodeURIComponent(url)
  } catch (e) {
    return false
  }
}
